import React from "react";
import { Route, Switch } from "react-router-dom";
import { LoginLayout } from "../Layout/Layout";
import { AlreadyLoggedIn } from "./AlreadyLoggedIn/AlreadyLoggedIn";
import { LoginAcceptedInvitation } from "./LoginAcceptedInvitation/LoginAcceptedInvitation";
import { LoginAppSelect } from "./LoginAppSelect/LoginAppSelect";
import { LoginCompleteSetup } from "./LoginCompleteSetup/LoginCompleteSetup";
import { LoginContainer } from "./LoginContainer/LoginContainer";
import { LoginOnboardingForm } from "./LoginOnboardingForm/LoginOnboardingForm";
import { LoginRequestPasswordReset } from "./LoginRequestPasswordReset/LoginRequestPasswordReset";
import { LoginSelectDetailedApp } from "./LoginSelectDetailedApp/LoginSelectDetailedApp";
import { LoginSetNewPassword } from "./LoginSetNewPassword/LoginSetNewPassword";

export const Login = () => {
  return (
    <div className="Login">
      <LoginLayout>
        <Switch>
          <Route
            path="/login/reset"
            exact
            render={() => (
              <LoginContainer title="pageTitles.resetPassword">
                <LoginRequestPasswordReset />
              </LoginContainer>
            )}
          />
          <Route
            path="/login/reset/:id"
            exact
            render={() => (
              <LoginContainer title="pageTitles.newPassword">
                <LoginSetNewPassword />
              </LoginContainer>
            )}
          />
          <Route
            path="/login/apps"
            exact
            render={() => (
              <LoginContainer title="pageTitles.loginWhere">
                <LoginAppSelect />
              </LoginContainer>
            )}
          />
          <Route
            path="/login/apps/:app"
            exact
            render={() => (
              <LoginContainer>
                <LoginSelectDetailedApp />
              </LoginContainer>
            )}
          />
          <Route
            path="/login/invite"
            exact
            render={() => (
              <LoginContainer title="pageTitles.createNewUser">
                <LoginCompleteSetup />
              </LoginContainer>
            )}
          />
          <Route
            path="/login/accept-invite"
            exact
            render={() => (
              <LoginContainer>
                <LoginAcceptedInvitation />
              </LoginContainer>
            )}
          />
          <Route
            path={["/login", "/login/authenticate", "/login/eflow-onboarding"]}
            exact
            render={() => (
              <AlreadyLoggedIn>
                <LoginContainer title="loginForm.login">
                  <LoginOnboardingForm />
                </LoginContainer>
              </AlreadyLoggedIn>
            )}
          />
          <Route
            path="/login/:email"
            exact
            render={() => (
              <AlreadyLoggedIn>
                <LoginContainer title="loginForm.login">
                  <LoginOnboardingForm />
                </LoginContainer>
              </AlreadyLoggedIn>
            )}
          />
        </Switch>
      </LoginLayout>
    </div>
  );
};
